import { deleteAsync, getAsync, patchAsync, postAsync, putAsync } from "./http-client";

const ReviewApi = {
  get: async (request) => {
    return await postAsync("/ceo/review/list", request);
  },
  edit: async (request) => {
    return await putAsync("/review/comment/", request);
  },
  write: async (reviewIdx) => {
    return await postAsync(`/review/comment/${reviewIdx}`);
  },
  getSavedSetting: async (shopIndex) => {
    return await getAsync(`/shop/setting/${shopIndex}`);
  },
  saveAutoPostCommentDay: async (request) => {
    return await patchAsync("/shop/setting", request);
  },
  deleteAddition: async (additionalCommentIdx) => {
    return await deleteAsync(`/additionalComment/${additionalCommentIdx}`);
  },
  createAddition: async (request) => {
    return await postAsync(`/additionalComment/`, request);
  },
  editAddition: async (request) => {
    return await putAsync(`/additionalComment/`, request);
  },
  getAdditionContent: async (shopIdx) => {
    return await getAsync(`/additionalComment/shop/${shopIdx}`);
  },
  exclude: async (reviewIdx) => {
    return await patchAsync(`/review/comment/exclude/${reviewIdx}`);
  },
  editForNormalUser: async (request) => {
    return await putAsync("/review/comment/normalUser", request);
  },
};
export default ReviewApi;